export const login = {
  email_label: "Email address",
  password_label: "Password",
  remember_me: "Remember me",
  forgot_password: "Forgot password",
  btn_signin: "Sign in",
  unable_to_login: "Can't log in?",
  resend_confirmation_email: "Resend confirmation email",
  no_account: "Don't have an account?",
  btn_signup: "Sign up for free",
  title: "Login",
  email_invalid: "Invalid email",
  email_required: "Email is required",
  password_min: "At least 6 characters",
  password_required: "Password is required",
  invalid_credentials: "Incorrect email or password",
  signup: "Sign up for free",
  dont_have_account: "Don’t have an account?",
  confirmEmail: "Confirm your email address",
  enterCodeInstruction: "Please enter the code sent to your email address",
  resendEmail: "Resend email",
  contactSupport: "If you didn’t receive an email, contact support",
  confirm: "Confirm",
  reset_password: "Reset password",
  email_placeholder: "Reset password",
  verifying: "verifying..",
  send: "sent",
};
